import { Loader } from '@systemeio/ui'
import { useTranslation } from 'react-i18next'
import { LibraryElementTypes } from '../../../../enums/libraryElementTypes'
import { managementSelectors, useTypedSelector } from '../../../../store'
import LibraryElement from './LibraryElement'
import { twMerge } from 'tailwind-merge'
import { SIDE_MENU_PADDING } from '../constants/style-constants'

const Library = () => {
  const { t } = useTranslation()
  const isFetching = useTypedSelector(({ management }) =>
    managementSelectors.isFetching(management),
  )

  if (isFetching) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Loader />
      </div>
    )
  }

  return (
    <div className={twMerge('flex flex-col gap-5', SIDE_MENU_PADDING)}>
      <div className="flex flex-col gap-3">
        <span className="text-text-primary text-lg font-bold">
          {t('core.library.groups.content.title')}
        </span>
        <div className="flex flex-wrap gap-5">
          <LibraryElement type={LibraryElementTypes.LibraryImage} />
          <LibraryElement type={LibraryElementTypes.LibraryText} />
          <LibraryElement type={LibraryElementTypes.LibraryButton} />
          <LibraryElement type={LibraryElementTypes.LibraryHorizontalLine} />
        </div>
      </div>
      <div className="flex flex-col gap-3">
        <span className="text-text-primary text-lg font-bold">
          {t('core.library.groups.layout.title')}
        </span>
        <div className="flex flex-wrap gap-5">
          <LibraryElement type={LibraryElementTypes.LibraryLayout_12} />
          <LibraryElement type={LibraryElementTypes.LibraryLayout_6_6} />
          <LibraryElement type={LibraryElementTypes.LibraryLayout_4_4_4} />
          <LibraryElement type={LibraryElementTypes.LibraryLayout_3_3_3_3} />
        </div>
      </div>
    </div>
  )
}

export default Library
